// Application layout shell — the chrome that wraps every authenticated route.
//
// Composition:
//   - <TopNav>   : sticky navigation bar with wordmark, primary links, sign-out
//   - <Outlet>   : react-router slot where the matched child route renders
//
// The starfield background is owned by `body.bg-starfield` (see
// `src/theme/orbital.css` § base) so it lives behind every route including
// /login — no per-route gradient plumbing needed. We avoid wrapping the
// outlet in an extra opaque container so the gradient bleeds through.

import { Outlet } from 'react-router-dom';
import { TopNav } from './TopNav';

export function Layout() {
  return (
    <div className="min-h-screen flex flex-col">
      <TopNav />
      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
    </div>
  );
}
